import {
    AdditionalRoomIcon,
    AreaIcon,
    CalendarCheckIcon,
    FloorIcon,
    FloorsIcon,
    KitchenIcon,
    MapMarkerOutlineIcon,
    PhoneIcon,
    PriceIcon,
    RoomHeightIcon,
    RoomsIcon,
    WorldSideIcon
} from "@pg-design/icons-module";
import {IComparisonTableRow} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {AdditionalAreasCell} from "../components/ComparisonToolTable/cell_renderer/AdditionalAreasCell";
import {AreaCell} from "../components/ComparisonToolTable/cell_renderer/AreaCell";
import {ChangePlaceCell} from "../components/ComparisonToolTable/cell_renderer/ChangePlaceCell";
import {ConstructionDateCell} from "../components/ComparisonToolTable/cell_renderer/ConstructionDateCell";
import {ContactCell} from "../components/ComparisonToolTable/cell_renderer/ContactCell";
import {DistanceFromCenterCell} from "../components/ComparisonToolTable/cell_renderer/DistanceFromCenterCell";
import {FloorCell} from "../components/ComparisonToolTable/cell_renderer/FloorCell";
import {FloorsCell} from "../components/ComparisonToolTable/cell_renderer/FloorsCell";
import {KitchenCell} from "../components/ComparisonToolTable/cell_renderer/KitchenCell";
import {PriceCell} from "../components/ComparisonToolTable/cell_renderer/PriceCell";
import {QuartersCell} from "../components/ComparisonToolTable/cell_renderer/QuartersCell";
import {RoomHeightCell} from "../components/ComparisonToolTable/cell_renderer/RoomHeightCell";
import {RoomsCell} from "../components/ComparisonToolTable/cell_renderer/RoomsCell";
import {ChangePlaceTableRowHeader} from "../components/ComparisonToolTable/header_renderer/ChangePlaceTableRowHeader";
import {ComparisonToolTableHeader} from "../utils/ComparisonToolTableHeader";

export const comparisonToolTableRows: IComparisonTableRow<IPropertyDetail>[] = [
    {
        key: ComparisonToolTableHeader.CONSTRUCTION_DATE,
        rowHeader: {
            label: "Termin oddania",
            icon: CalendarCheckIcon
        },
        cell: ConstructionDateCell
    },
    {
        key: ComparisonToolTableHeader.AREA,
        rowHeader: {
            label: "Metraż",
            icon: AreaIcon
        },
        cell: AreaCell
    },
    {
        key: ComparisonToolTableHeader.PRICE,
        rowHeader: {
            label: "Cena",
            icon: PriceIcon
        },
        cell: PriceCell
    },
    {
        key: ComparisonToolTableHeader.ROOMS,
        rowHeader: {
            label: "Liczba pokoi",
            icon: RoomsIcon
        },
        cell: RoomsCell
    },
    {
        key: ComparisonToolTableHeader.FLOOR,
        rowHeader: {
            label: "Piętro",
            icon: FloorIcon
        },
        cell: FloorCell
    },
    {
        key: ComparisonToolTableHeader.QUARTERS,
        rowHeader: {
            label: "Strona świata",
            icon: WorldSideIcon
        },
        cell: QuartersCell
    },
    {
        key: ComparisonToolTableHeader.KITCHEN,
        rowHeader: {
            label: "Typ kuchni",
            icon: KitchenIcon
        },
        cell: KitchenCell
    },
    {
        key: ComparisonToolTableHeader.ADDITIONAL_AREAS,
        rowHeader: {
            label: "Powierzchnie dodatkowe",
            icon: AdditionalRoomIcon
        },
        cell: AdditionalAreasCell
    },
    {
        key: ComparisonToolTableHeader.ROOM_HEIGHT,
        rowHeader: {
            label: "Wysokość pomieszczeń",
            icon: RoomHeightIcon
        },
        cell: RoomHeightCell
    },
    {
        key: ComparisonToolTableHeader.FLOORS,
        rowHeader: {
            label: "Kondygnacje",
            icon: FloorsIcon
        },
        cell: FloorsCell
    },
    {
        key: ComparisonToolTableHeader.DISTANCE,
        rowHeader: {
            label: "Odległość od centrum",
            icon: MapMarkerOutlineIcon
        },
        cell: DistanceFromCenterCell
    },
    {
        key: ComparisonToolTableHeader.CHANGE_PLACE,
        rowHeader: ChangePlaceTableRowHeader,
        cell: ChangePlaceCell
    },
    // TODO: Add in phase 2
    // {
    //     key: ComparisonToolTableHeader.NOTES,
    //     header: {
    //         label: "Moje notatki",
    //         icon: EditIcon
    //     }
    // },
    {
        key: ComparisonToolTableHeader.CONTACT,
        rowHeader: {
            label: "Skontaktuj się z deweloperem ",
            icon: PhoneIcon
        },
        cell: ContactCell
    }
];
import {
    AdditionalRoomIcon,
    AreaIcon,
    CalendarCheckIcon,
    FloorIcon,
    FloorsIcon,
    KitchenIcon,
    MapMarkerOutlineIcon,
    PhoneIcon,
    PriceIcon,
    RoomHeightIcon,
    RoomsIcon,
    WorldSideIcon
} from "@pg-design/icons-module";
import {IComparisonTableRow} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {AdditionalAreasCell} from "../components/ComparisonToolTable/cell_renderer/AdditionalAreasCell";
import {AreaCell} from "../components/ComparisonToolTable/cell_renderer/AreaCell";
import {ChangePlaceCell} from "../components/ComparisonToolTable/cell_renderer/ChangePlaceCell";
import {ConstructionDateCell} from "../components/ComparisonToolTable/cell_renderer/ConstructionDateCell";
import {ContactCell} from "../components/ComparisonToolTable/cell_renderer/ContactCell";
import {DistanceFromCenterCell} from "../components/ComparisonToolTable/cell_renderer/DistanceFromCenterCell";
import {FloorCell} from "../components/ComparisonToolTable/cell_renderer/FloorCell";
import {FloorsCell} from "../components/ComparisonToolTable/cell_renderer/FloorsCell";
import {KitchenCell} from "../components/ComparisonToolTable/cell_renderer/KitchenCell";
import {PriceCell} from "../components/ComparisonToolTable/cell_renderer/PriceCell";
import {QuartersCell} from "../components/ComparisonToolTable/cell_renderer/QuartersCell";
import {RoomHeightCell} from "../components/ComparisonToolTable/cell_renderer/RoomHeightCell";
import {RoomsCell} from "../components/ComparisonToolTable/cell_renderer/RoomsCell";
import {ChangePlaceTableRowHeader} from "../components/ComparisonToolTable/header_renderer/ChangePlaceTableRowHeader";
import {ComparisonToolTableHeader} from "../utils/ComparisonToolTableHeader";

export const comparisonToolTableRows: IComparisonTableRow<IPropertyDetail>[] = [
    {
        key: ComparisonToolTableHeader.CONSTRUCTION_DATE,
        rowHeader: {
            label: "Termin oddania",
            icon: CalendarCheckIcon
        },
        cell: ConstructionDateCell
    },
    {
        key: ComparisonToolTableHeader.AREA,
        rowHeader: {
            label: "Metraż",
            icon: AreaIcon
        },
        cell: AreaCell
    },
    {
        key: ComparisonToolTableHeader.PRICE,
        rowHeader: {
            label: "Cena",
            icon: PriceIcon
        },
        cell: PriceCell
    },
    {
        key: ComparisonToolTableHeader.ROOMS,
        rowHeader: {
            label: "Liczba pokoi",
            icon: RoomsIcon
        },
        cell: RoomsCell
    },
    {
        key: ComparisonToolTableHeader.FLOOR,
        rowHeader: {
            label: "Piętro",
            icon: FloorIcon
        },
        cell: FloorCell
    },
    {
        key: ComparisonToolTableHeader.QUARTERS,
        rowHeader: {
            label: "Strona świata",
            icon: WorldSideIcon
        },
        cell: QuartersCell
    },
    {
        key: ComparisonToolTableHeader.KITCHEN,
        rowHeader: {
            label: "Typ kuchni",
            icon: KitchenIcon
        },
        cell: KitchenCell
    },
    {
        key: ComparisonToolTableHeader.ADDITIONAL_AREAS,
        rowHeader: {
            label: "Powierzchnie dodatkowe",
            icon: AdditionalRoomIcon
        },
        cell: AdditionalAreasCell
    },
    {
        key: ComparisonToolTableHeader.ROOM_HEIGHT,
        rowHeader: {
            label: "Wysokość pomieszczeń",
            icon: RoomHeightIcon
        },
        cell: RoomHeightCell
    },
    {
        key: ComparisonToolTableHeader.FLOORS,
        rowHeader: {
            label: "Kondygnacje",
            icon: FloorsIcon
        },
        cell: FloorsCell
    },
    {
        key: ComparisonToolTableHeader.DISTANCE,
        rowHeader: {
            label: "Odległość od centrum",
            icon: MapMarkerOutlineIcon
        },
        cell: DistanceFromCenterCell
    },
    {
        key: ComparisonToolTableHeader.CHANGE_PLACE,
        rowHeader: ChangePlaceTableRowHeader,
        cell: ChangePlaceCell
    },
    // TODO: Add in phase 2
    // {
    //     key: ComparisonToolTableHeader.NOTES,
    //     header: {
    //         label: "Moje notatki",
    //         icon: EditIcon
    //     }
    // },
    {
        key: ComparisonToolTableHeader.CONTACT,
        rowHeader: {
            label: "Skontaktuj się z deweloperem ",
            icon: PhoneIcon
        },
        cell: ContactCell
    }
];
